import React from 'react';

import { Button, Group, MultiSelect, Title, useMantineTheme } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';

import { AthletePackageSearchFilters } from '../types';

const statusOptions: AthletePackageSearchFilters['statuses'] = [
  'ACTIVE',
  'UPCOMING',
  'ENDED',
  'CANCELLED',
  'HOLD',
];

const AthletePackagesFilters = ({
  searchFilters,
  setSearchFilters,
  handleOpenCreateForm,
  permission = true,
}: {
  searchFilters: AthletePackageSearchFilters;
  setSearchFilters: React.Dispatch<React.SetStateAction<AthletePackageSearchFilters>>;
  handleOpenCreateForm: () => void;
  permission?: boolean;
}): JSX.Element => {
  const theme = useMantineTheme();

  const handleIsShowHistoricalChange = (value: AthletePackageSearchFilters['statuses']): void => {
    setSearchFilters(prev => ({ ...prev, statuses: value }));
  };

  return (
    <Group noWrap position='apart' p='xl' pb='xs'>
      <Title order={2} size='h2'>
        Packages
      </Title>
      <Group noWrap>
        <MultiSelect
          pr='xl'
          miw={350}
          placeholder='Select statuses'
          clearable
          data={statusOptions}
          value={searchFilters.statuses}
          onChange={handleIsShowHistoricalChange}
        />

        <Button
          leftIcon={<IconPlus size={theme.fontSizes.md} />}
          onClick={handleOpenCreateForm}
          size='xs'
          disabled={!permission}
          data-cy='addPackageToAthleteButton'
        >
          Package
        </Button>
      </Group>
    </Group>
  );
};

export default AthletePackagesFilters;
